export default __webpack_public_path__ + "Revenue_Calculator_New_Product_Template_NA-en-US.96baf1e7.xlsx";